import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

import ShareModal from './components/ShareModal';

export default function (corpId: string, agentId: string) {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    if (items.has('share-social')) {
      const vnode = items.get('share-social');
      const originOnClick = vnode.attrs.onclick;
      vnode.attrs.onclick = () => {
        originOnClick();
        setTimeout(() => {
          const group = document.querySelector('.FofShareSocialModal .Form-group');
          const button = document.createElement('button');
          const span = document.createElement('span');
          span.className = 'Button-label';
          span.innerText = '企业微信';
          button.className = 'Button Button--rounded Button--block Share--wecom';
          button.type = 'button';
          button.onclick = () => {
            // @ts-ignore
            ShareModal.shareToWeCom(this.discussion);
          };
          button.appendChild(span);
          group?.insertBefore(button, group.firstChild);
        }, 10);
      };
    } else {
      items.add(
        'share-social',
        <Button
          class="Button Button-icon Button--share"
          icon="fas fa-share-alt"
          onclick={() =>
            app.modal.show(ShareModal, {
              // @ts-ignore
              discussion: this.discussion,
            })
          }
        >
          分享
        </Button>
      );
    }
  });
}
